<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h-2"><a id="page_v"></a>CONTENTS</h2>
<p class="TOC-Chapter"><span class="small">PREFACE: WHAT <em>IS</em> LIBERAL CHRISTIANITY?</span>   <a class="nounder" href="#/9780230240582_07_preface#pref">vii</a></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter"><span class="small">            PART ONE: HOW A LIBERAL CHRISTIAN LOOKS AT RELIGION</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter">Chapter 1   Some Liberal Perspectives: Jesus, Science, Abortion, and Same-Sex Marriage   <a class="nounder" href="#/9780230240582_09_chap01#chap01">3</a></p>
<p class="TOC-Chapter">Chapter 2   The Essence of Liberal Christianity   <a class="nounder" href="#/9780230240582_10_chap02#chap02">27</a></p>
<p class="TOC-Chapter">Chapter 3   God   <span class="nounder" href="#/9780230240582_11_chap03#chap03" title="Link target outside of Sample">44</span></p>
<p class="TOC-Chapter">Chapter 4   Jesus and the Church   <span class="nounder" href="#/9780230240582_12_chap04#chap04" title="Link target outside of Sample">63</span></p>
<p class="TOC-Chapter">Chapter 5   Understanding the Bible   <span class="nounder" href="#/9780230240582_13_chap05#chap05" title="Link target outside of Sample">78</span></p>
<p class="TOC-Chapter">Chapter 6   Faith   <span class="nounder" href="#/9780230240582_14_chap06#chap06" title="Link target outside of Sample">97</span></p>
<p class="TOC-Chapter">Chapter 7   Talking to Atheists and Christian Conservatives   <span class="nounder" href="#/9780230240582_15_chap07#chap07" title="Link target outside of Sample">113</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter"><span class="small">            PART TWO: A LIBERAL CHRISTIAN QUESTIONS SOCIETY</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter">Chapter 8   The Great Social Issues: Poverty, Bigotry, War, and Environmental Destruction   <span class="nounder" href="#/9780230240582_17_chap08#chap08" title="Link target outside of Sample">135</span></p>
<p class="TOC-Chapter">Chapter 9   Church and State   <span class="nounder" href="#/9780230240582_18_chap09#chap09" title="Link target outside of Sample">157</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter"><span class="small">            PART THREE: LIVING THE LIBERAL CHRISTIAN LIFE</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter">Chapter 10   Christian Doctrine: The Trinity, Communion, Being Born Again, the Apocalypse, and the Sabbath   <span class="nounder" href="#/9780230240582_20_chap10#chap10" title="Link target outside of Sample">177</span></p>
<p class="TOC-Chapter">Chapter 11   The Church Year: Advent, Christmas, Holy Week, and Easter   <span class="nounder" href="#/9780230240582_21_chap11#chap11" title="Link target outside of Sample">199</span></p>
<p class="noindent"><br/><br/></p>
<p class="TOC-Chapter"><span class="small">EPILOGUE RECLAIMING LIBERAL CHRISTIANITY</span>   <span class="nounder" href="#/9780230240582_22_epilogue#epi" title="Link target outside of Sample">215</span></p>
<p class="TOC-Chapter"><span class="small">ACKNOWLEDGMENTS</span>   <span class="nounder" href="#/9780230240582_23_ack#ack" title="Link target outside of Sample">227</span></p>
<p class="TOC-Chapter"><span class="small">SUGGESTIONS FOR FURTHER READING</span>   <a class="nounder" href="#/9780230240582_24_furreading#fur">228</a></p>
<p class="TOC-Chapter"><span class="small">NOTES</span>   <span class="nounder" href="#/9780230240582_25_notes#notes" title="Link target outside of Sample">231</span></p>
<p class="TOC-Chapter"><span class="small">INDEX</span>   <span class="nounder" href="#/9780230240582_26_index#index" title="Link target outside of Sample">254</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_05_contents.vue?10f75ee3